import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { GlobalService } from '../core/global.service';
import { Observable } from 'rxjs';
import { GlobalNamespace as _GlobalNS } from '../../environments/environment';
import { PartnerUserDataGroup } from './models/partner';
import { PartnerUser } from './models/PartnerUser';

@Injectable({
  providedIn: 'root'
})
export class PartnerUserService {

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json'
    })
  };

  constructor(private _http: HttpClient, private _global: GlobalService) { }

  find(): Observable<any> {
    const api = (<any>_GlobalNS).api.partner.user;
    const eqrf = this._global.find((<any>_GlobalNS).paths.eqrf);
    const params = new HttpParams().set('relationshipId', this._global.find((<any>_GlobalNS).paths.RelationshipId));
    return this._http.get(`${api}&eqrf=${eqrf}`, {params});
  }

  update(relationshipID: number, partnerUser: PartnerUserDataGroup) {
    const api = (<any>_GlobalNS).api.partner.user;
    const eqrf = this._global.find((<any>_GlobalNS).paths.eqrf);
    return this._http.post(`${api}&eqrf=${eqrf}`, {'RelationshipId': relationshipID, 'PartnerUser': partnerUser.PartnerUser}, this.httpOptions);
  }

  deactivateUser(relationshipID: number, partnerUser: PartnerUser) {
    const api = (<any>_GlobalNS).api.partner.user;
    const eqrf = this._global.find((<any>_GlobalNS).paths.eqrf);
    return this._http.post(`${api}&eqrf=${eqrf}`, {'RelationshipId': relationshipID, 'PartnerUser': partnerUser}, this.httpOptions);
  }
}
